import getInfoBarMessageViewState from './getInfoBarMessageViewState';
import InfoBarViewState from 'owa-info-bar/lib/schema/InfoBarViewState';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientMessage, InstrumentationContext } from 'owa-mail-store';

export default function createInfoBarViewState(
    message: ClientMessage,
    instrumentationContexts: InstrumentationContext[],
    itemViewState: ItemViewState
): InfoBarViewState {
    const infoBarViewState: InfoBarViewState = {
        messages: [],
    };

    for (const messageId of itemViewState.infoBarIds) {
        const infoBarMessageViewState = getInfoBarMessageViewState(
            messageId,
            message,
            instrumentationContexts,
            itemViewState
        );

        if (infoBarMessageViewState) {
            infoBarViewState.messages.push(infoBarMessageViewState);
        }
    }

    return infoBarViewState;
}
